/*
 * @Author: your name
 * @Date: 2021-10-25 10:43:46
 * @LastEditTime: 2023-03-16 17:31:04
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\deviceAccess\api\index.js
 */
export const api = {
  device: {
    // VCN相关接口
    selectBigDeviceType: '/dgw/mvc/accessdeviceinfo/selectBigDeviceType', // 查询系统类型
    selectSystemInfoList: '/dgw/mvc/vcn/selectSystemInfoList', // 用于查询平台时，接口调用
    selectPlugInfo: '/dgw/mvc/vcn/selectPlugInfo', // 新增系统时查询插件信息
    selectFactory: '/dgw/mvc/vcn/selectFactory', // 新增系统时查询厂家信息
    addSystemInfo: '/dgw/mvc/vcn/addSystemInfo', // 新增系统提交数据
    selectSystemInfo: '/dgw/mvc/vcn/selectSystemInfo', // 查询系统详情
    updateSystemInfo: '/dgw/mvc/vcn/updateSystemInfo', // 修改系统详情
    deleteSystemInfo: '/dgw/mvc/vcn/deleteSystemInfo', // 卸载系统
    getChildDeviceInfo: '/dgw/mvc/accessdeviceinfo/getChildDeviceInfo', // 用于设备树根节点查询时
    getVcnDeviceList: '/dgw/mvc/vcnController/getVcnDeviceList', // 查询VCN设备列表
    deleteVcnDevices: '/dgw/mvc/vcnController/deleteVcnDevices', // 删除vcn设备方法
    synchronVCN: '/dgw/mvc/imesController/synchronIMES', // 设备同步接口
    getVcnDeviceDetail: '/dgw/mvc/vcnController/getVcnDeviceDetail', // 查询VCN设备详情
    vcnQuerySystemConfigure: '/cms/accessportal/vcnQuerySystemConfigure', // 查询系统的事件配置
    vcnConfigureDeviceEunmInfo: '/cms/accessportal/vcnConfigureDeviceEunmInfo', // 查询事件名称
    vcnConfigureDeviceEventType:
      '/cms/accessportal/vcnConfigureDeviceEventType', // 获取配置的告警级别、事件类型、处理方式
    vcnUpdateConfigure: '/cms/accessportal/vcnUpdateConfigure', // 修改事件配置
    selectAreaInfoList: '/dgw/mvc/vcn/selectAreaInfoList', // 查询控制中心接口
    enableAlarmTaskRule: '/cms/accessportal/enableAlarmTaskRule.json', // 启用告警任务派发规则信息
    queryAlarmTaskRule: '/cms/accessportal/queryAlarmTaskRule.json', //查询告警任务派发规则信息
    updateAlarmTaskRule: '/cms/accessportal/updateAlarmTaskRule.json', //配置告警任务派发规则
    querySecurityWorkGroup: '/cms/workgroup/querySecurityWorkGroup.json', // 查询工作组信息
    queryAccountList: '/cms/account/queryResultsByPagApi.json', // 查询帐户信息信息
    // 迭代四 功能优化 新接口
    syncDevice: 'cms/accessportal/syncDevice.json', //设备接入同步设备
    syncNvrDevice: 'cms/accessportal/syncNvrDevice.json', //设备接入同步NVR设备
    queryPlatSystemList: 'cms/accessportal/queryPlatSystemListApi.json', //设备接入查询平台系统列表
    queryPlatSystemStatus: 'cms/accessportal/queryPlatSystemStatus.json', //设备接入查询平台系统状态
    queryPlatSystemDeviceTree:
      'cms/accessportal/queryPlatSystemDeviceTree.json', //设备接入查询平台系统设备树
    queryAreaList: 'cms/accessportal/queryAreaList.json', //查询设备接入区域列表
    updateArea: 'cms/accessportal/updateArea.json', //修改设备接入区域
    queryEdgeNodeList: 'cms/accessportal/queryEdgeNodeList.json', //查询边缘节点列表
    queryCameraCount: '/cms/accessportal/queryCameraCount.json', //查询NVR接入摄像机总数/在线/离线数量接口
    queryFactoryList: 'cms/accessportal/queryFactoryList.json', //查询厂商列表
    addPlatSystemDevice: 'cms/accessportal/addPlatSystemDevice.json', //新增nvr平台
    deletePlatDevice: 'cms/accessportal/deletePlatDevice.json', //删除nvr平台
    queryVideoStream: 'vas/video/queryVideoStreamListByDevice.json', //删除nvr平台

    // 设备
    queryPlatSystemDeviceList:
      'cms/accessportal/queryPlatSystemDeviceList.json', //设备接入查询平台系统设备列表
    queryPlatSystemDeviceListIot:
      '/cms/accessportal/querySystemDeviceList.json', //设备接入查询平台系统设备列表IOT
    queryPlatSystemDeviceDetail:
      'cms/accessportal/queryPlatSystemDeviceDetail.json', //设备接入查询平台系统设备详情
    deletePlatSystemDevice: '/cms/accessportal/deletePlatSystemDevice.json', //设备接入删除平台系统设备
    addPlatSystemDeviceList: '/cms/accessportal/addDevice.json',
    updatePlatSystemDeviceList: '/cms/accessportal/updateDevice.json',

    // 迭代五 消防接口
    importFireDevice: 'cms/accessportal/importFireDevice.json', //设备接入导入设备
    addFireDevice: 'cms/accessportal/addFireDevice.json', //设备接入新增消防主机
    updateFireDevice: 'cms/accessportal/updateFireDevice.json', //修改消防主机
    deleteFireDevice: 'cms/accessportal/deleteFireDevice.json', //删除消防主机 & 删除主机下部件
    queryFireDevice: 'cms/accessportal/queryFireDevice.json', //查询消防主机
    addFireSubDevice: 'cms/accessportal/addFireSubDevice.json', //新增消防主机部件
    updateFireSubDevice: 'cms/accessportal/updateFireSubDevice.json', //修改消防主机部件
    queryFireSubDevice: 'cms/accessportal/queryFireSubDevice.json', //查询消防主机部件
    exportFireDevice: 'cms/accessportal/exportFireDevice.json ', //导出消防主机
    queryFireDeviceFactoryList:
      'cms/accessportal/queryFireDeviceFactoryList.json', //查询主机厂商
    updateDeviceUnlockPassword: '/bms/device/updateDeviceUnlockPassword.json', //设置密码
    getFireFightingControlCodeTypeList:
      '/bms/device/queryFireFightingControlCodeTypeList.json', //获取消防控制器编号list
    updateFireFightingControlCodeType:
      '/bms/device/updateFireFightingControlCodeType.json', //修改消防控制器编号名称

    // 一键求救
    querySosDevice: '/cms/accessportal/querySosDeviceList.json', //查询一键求救设备
    addSosDevice: '/cms/accessportal/addSosDevice.json', //add一键求救设备
    updateSosDevice: '/cms/accessportal/updateSosDevice.json', //update一键求救设备

    // 告警抑制
    queryAlarmIgnoreConfigList:
      '/cms/accessportal/queryAlarmIgnoreConfigList.json', //查询告警抑制
    updateAlarmIgnoreConfig: '/cms/accessportal/updateAlarmIgnoreConfig.json', //修改告警抑制
    deleteAlarmIgnoreConfig: '/cms/accessportal/deleteAlarmIgnoreConfig.json', //删除告警抑制
    getAlarmTypeAndSubsystem:
      '/bas/alarmSafeEvent/queryAlarmTypeAndSubsystem.json', //获取子系统及高级类型级联数据
    getTemplateFile:
      '/common/file/downLoadTemplateFile.json?templateFileName=importAlarmIgnoreConfig.xlsx', //下载模板
    importTemplateFile: '/cms/accessportal/importAlarmIgnoreConfig.json' //批量导入
  },
  fire: {
    deleteAlarmEventRule: '/cms/accessportal/deleteAlarmEventRule.json', //消防事件配置删除
    addAlarmEventRule: '/cms/accessportal/addAlarmEventRule.json', //消防事件配置新增
    updateAlarmEventRule: '/cms/accessportal/updateAlarmEventRule.json', //消防事件配置修改
    getTemplateFile:
      '/common/file/downLoadTemplateFile.json?templateFileName=importFireSubDevice.xlsx', //下载模板
    importFireDevice: '/cms/accessportal/importFireSubDevice.json'
  },
  fireTruck: {
    queryFireTruckDevice: '/cms/accessportal/queryFireTruckDevice.json', //查询消防车接口
    addFireTruckDevice: '/cms/accessportal/addFireTruckDevice.json', //新增消防车设备接口
    updateFireTruckDevice: '/cms/accessportal/updateFireTruckDevice.json' //修改消防车设备接口
  },
  //电气火灾设备接入
  electricFire: {
    addElectricalFireDevice: '/cms/accessportal/addElectricalFireDevice.json', //电气火灾新增接口
    updateElectricalFireDevice:
      '/cms/accessportal/updateElectricalFireDevice.json', //电气火灾修改接口
    deleteElectricalFireDevice:
      '/cms/accessportal/deleteElectricalFireDevice.json', //电气火灾删除接口
    queryElectricalFireDevice:
      '/cms/accessportal/queryElectricalFireDevice.json' //电气火灾查询接口
  },
  //可燃气体,iot设备新增
  gasTruck: {
    addDevice: '/cms/accessportal/addDevice.json',
    updateDevice: '/cms/accessportal/updateDevice.json',
    importGasDevice: '/cms/accessportal/importGasDevice.json',
    deleteDevice: '/cms/accessportal/deleteDevice.json',
    
    getTemplateFile:
      '/common/file/downLoadTemplateFile.json?templateFileName=importGasTemplate.xlsx' //下载模板
  }
}
